import { useContext } from "react";
import { LanguageContext } from "../LanguageContext";
import { Link } from "react-router-dom";
import React from "react";

export function TermsLink() {
    const { language: currentLanguage } = useContext(LanguageContext);
    return (
        <p>
            {currentLanguage === "fr" ? (
                <>
                    En continuant, vous acceptez les{" "}
                    <a target="_blank" href="/terms-and-conditions">
                        conditions générales
                    </a>{" "}
                    de ConsumerHouse. Voir{" "}
                    <a target="_blank" href="/gdpr">
                        ici
                    </a>{" "}
                    comment nous traitons vos données.
                </>
            ) : (
                <>
                    Als je verder gaat, ga je akkoord met de{" "}
                    <a target="_blank" href="/terms-and-conditions">
                        algemene voorwaarden
                    </a>{" "}
                    van ConsumerHouse. Zie{" "}
                    <a target="_blank" href="/gdpr">
                        hier
                    </a>{" "}
                    hoe we om gaan met jouw data.
                </>
            )}
        </p>
    );
}
